import { Inject, Injectable } from "@angular/core";
import { AbstractService } from "./abstract-service.service";
import { HttpClient } from "@angular/common/http";
import { APP_CONFIG, AppConfig } from "./config";
import { Response } from "../Models/response";
import { DeliveryAddress } from "../Models/DeliveryAddress";

@Injectable({
  providedIn: "root",
})
export class DeliveryService extends AbstractService<DeliveryAddress, number> {
  url: string;

  constructor(http: HttpClient, @Inject(APP_CONFIG) config: AppConfig) {
    super(http);
    this.url = `${config.apiEndpoint}/new/delivery`;
  }

  public getDeliveryPrice(
    address: DeliveryAddress,
    type: string,
    livreurId: number,
  ) {
    const url = `${this.url}/deliveryprice`;
    const delivery = {
      address: address,
      deliveryType: type,
      livreurId: livreurId,
    };
    return this.http.post<number>(url, delivery, { withCredentials: true });
  }

  public getDeliveryPriceYalidine(
    wilaya: string,
    commune: string,
    deliveryType: string,
  ) {
    const url = `${this.url}/deliveryprice/yalidine`;
    const delivery = {
      wilaya: wilaya,
      commune: commune,
      deliveryType: deliveryType,
    };
    return this.http.post<number>(url, delivery, { withCredentials: true });
  }
}
